import React, { useContext, useEffect, useMemo, useState } from 'react';
import classes from './PostEditorBody.module.scss';
import { UseFormReturn } from 'react-hook-form';
import classNames from 'classnames';
import { Tabs } from '../../../components/actions/Tabs';
import { Tab } from '../../../components/actions/Tabs/Tab';
import { PostContent } from '../PostContent';
import { Schedule } from '../Schedule';
import { PostPreview } from '../PostPreview';
import { PostEditorBulkImportCollapsedGroupElement } from '../PostEditorBulkImportCollapsedGroupElement';
import { CaptionWriter } from '../CaptionWriter';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';
// import { TourTip } from '../../Onboarding/TourTip';
import { useUserData } from '../../../hooks/useUserData';
import { OnboardingContext } from '../../Onboarding/states/OnboardingProvider';
import { isPostEditorActive } from '../../Onboarding/helpers/isPostEditorActive';
import { AppContext } from '../../../providers/AppProvider';

export type BulkImportEditorExpandProps =
  | { isBulkImport: true; expanded: boolean; counter: number }
  | { expanded?: never; isBulkImport?: never; counter?: never };
export type PostEditorBodyViewProps = {
  //
  formInstance: UseFormReturn;
  postId?: string;
} & BulkImportEditorExpandProps;

export const PostEditorBodyView = ({
  formInstance,
  postId,
  isBulkImport,
  expanded,
  counter
}: PostEditorBodyViewProps): JSX.Element => {
  const { postEditorContext } = useContext(AppContext);
  const [tabState, tabDispatch] = useContext(PostEditorGroupDataContext);
  const { state, showTourTips } = useContext(OnboardingContext);
  const [tourtipPreviewDesktopXY, setTourtipPreviewDesktopXY] = useState<{ top: number; left: number } | null>(null);
  const [tourtipPreviewMobileXY, _setTourtipPreviewMobileXY] = useState<{ top: number; left: number } | null>(null);
  const { userData } = useUserData();
  const { onboarding } = userData || {};
  const { stepsSeen } = onboarding || {};
  const { version } = state;
  const mobileView = tabState.tabs.tabsType === 'single';
  const { leftTabsIndex, rightTabsIndex } = tabState.tabs;
  const _previewActive = mobileView ? leftTabsIndex === 2 : rightTabsIndex === 1;
  const leftColumnClasses = classNames(
    'relative',
    'cell',
    'small-12',
    'tablet-portrait-auto',
    classes.TabsWrapper,
    classes.LeftColumn
  );
  const rightColumnClasses = classNames(
    'relative',
    'cell',
    'small-12',
    'tablet-portrait-6',
    'xlarge-auto',
    classes.TabsWrapper,
    classes.RightColumn
  );
  let _keyPreview = '';
  if (isPostEditorActive(postEditorContext) && showTourTips && stepsSeen) {
    switch (version) {
      case 1:
      default: {
        _keyPreview = 'v1_tourtip_post_editor_post_preview';
        break;
      }
    }
  }

  const shouldBlockPreviewMobileTab = false;
  // const shouldBlockPreviewMobileTab = !previewActive && !!keyPreview && !!tourtipPreviewMobileXY;

  const leftColumnTabs = useMemo(() => {
    let leftColumnTabs: JSX.Element[] = [
      <Tab
        header={mobileView ? 'Content' : isBulkImport ? `Post #${counter}` : 'Post Content'}
        key={'post-content-tab'}>
        {isBulkImport && !expanded ? (
          <PostEditorBulkImportCollapsedGroupElement />
        ) : (
          <PostContent formInstance={formInstance} />
        )}
      </Tab>
    ];

    if (mobileView) {
      leftColumnTabs = [
        ...leftColumnTabs,
        <Tab header={'Timing'} key={'schedule-tab'}>
          <Schedule formInstance={formInstance} postId={postId} hideCustomizeToggle={!!isBulkImport && !expanded} />
        </Tab>,
        <Tab
          header={'Preview'}
          key={'preview-tab'}
          {...(shouldBlockPreviewMobileTab ? { style: { pointerEvents: 'none' } } : {})}>
          <PostPreview />
        </Tab>,
        <Tab header={'AI Assistant'} key={'caption-writter-tab'}>
          <CaptionWriter />
        </Tab>
      ];
    }
    return leftColumnTabs;
  }, [expanded, formInstance, isBulkImport, mobileView, postId, counter, shouldBlockPreviewMobileTab]);

  useEffect(() => {
    if (!mobileView) {
      tabDispatch({ type: 'setIndex', payload: { side: 'left', value: 0 } });
    } else {
      setTourtipPreviewDesktopXY(null);
    }
  }, [mobileView, tabDispatch]);

  // const dotAction = useCallback(() => {
  //   const side = mobileView ? 'left' : 'right';
  //   const value = mobileView ? 2 : 1;
  //   tabDispatch({ type: 'setIndex', payload: { side, value } });
  // }, [mobileView, tabDispatch]);

  const separatorClasses = classNames('cell', classes.TabsWrapper, classes.TabsWrapperMiddleCol, classes.MiddleColumn);
  return (
    <div className={classNames('grid-x grid-padding-x grid-container', classes.ContainerWrapper)}>
      <div
        className={leftColumnClasses}
        ref={ref => {
          if (ref && !tourtipPreviewMobileXY && mobileView) {
            // const tabs = ref.querySelectorAll('li');
            // const left = Array.from(tabs).reduce(
            //   (prev, current) => {
            //     if (prev.done) return prev;
            //     const { width } = current.getBoundingClientRect();
            //     if (current.innerText.includes('Preview')) {
            //       return {
            //         left: prev.left + width / 2,
            //         done: true
            //       };
            //     }
            //     return {
            //       left: prev.left + width,
            //       done: prev.done
            //     };
            //   },
            //   { left: 0, done: false }
            // );
            // const previewTab = Array.from(tabs).find(tab => tab.innerText.includes('Preview'));
            // if (previewTab) {
            //   setTourtipPreviewMobileXY({ top: -8, left: left.left });
            // } else {
            //   setTourtipPreviewDesktopXY(null);
            // }
          }
        }}>
        <Tabs
          activeIndex={leftTabsIndex || 0}
          key={`left-tabs-mobile-${mobileView}-`}
          onTabChange={e => tabDispatch({ type: 'setIndex', payload: { side: 'left', value: e.index } })}>
          {leftColumnTabs}
        </Tabs>
        {/*{keyPreview && tourtipPreviewMobileXY ? (*/}
        {/*  <TourTip*/}
        {/*    dotAction={dotAction}*/}
        {/*    id={keyPreview}*/}
        {/*    tooltipPointerPosition={'BottomRight'}*/}
        {/*    offsetY={tourtipPreviewMobileXY.top}*/}
        {/*    offsetX={tourtipPreviewMobileXY.left}*/}
        {/*    offsetFromDotY={-12}*/}
        {/*    offsetFromDotX={-30}*/}
        {/*  />*/}
        {/*) : null}*/}
      </div>
      {mobileView ? null : (
        <>
          <div className={separatorClasses}>
            <div className={classes.VerticalSeparator}>
              <span className={'show-for-sr'}>v-devider</span>
            </div>
          </div>
          <div
            className={rightColumnClasses}
            ref={ref => {
              if (ref && !tourtipPreviewDesktopXY) {
                //   const tabs = ref.querySelectorAll('li');
                //   const left = Array.from(tabs).reduce(
                //     (prev, current) => {
                //       if (prev.done) return prev;
                //       const { width } = current.getBoundingClientRect();
                //       if (current.innerText.includes('Preview')) {
                //         return {
                //           left: prev.left + width / 2,
                //           done: true
                //         };
                //       }
                //       return {
                //         left: prev.left + width,
                //         done: prev.done
                //       };
                //     },
                //     { left: 0, done: false }
                //   );
                //   const previewTab = Array.from(tabs).find(tab => tab.innerText.includes('Preview'));
                //   if (previewTab) {
                //     setTourtipPreviewDesktopXY({ top: -8, left: left.left });
                //   } else {
                //     setTourtipPreviewMobileXY(null);
                //   }
              }
            }}>
            <Tabs
              activeIndex={rightTabsIndex || 0}
              onTabChange={e => tabDispatch({ type: 'setIndex', payload: { side: 'right', value: e.index } })}>
              <Tab header={'Timing'}>
                <Schedule
                  formInstance={formInstance}
                  postId={postId}
                  hideCustomizeToggle={!!isBulkImport && !expanded}
                />
              </Tab>
              <Tab header={'Preview'} {...{} /*{...(!previewActive && !!keyPreview && !!tourtipPreviewDesktopXY*/}>
                <PostPreview />
              </Tab>
              <Tab header={'AI Assistant'}>
                <CaptionWriter />
              </Tab>
            </Tabs>
            {/*{keyPreview && tourtipPreviewDesktopXY ? (*/}
            {/*  <TourTip*/}
            {/*    dotAction={dotAction}*/}
            {/*    id={keyPreview}*/}
            {/*    tooltipPointerPosition={'RightTop'}*/}
            {/*    offsetY={tourtipPreviewDesktopXY.top}*/}
            {/*    offsetX={tourtipPreviewDesktopXY.left}*/}
            {/*    offsetFromDotY={90}*/}
            {/*    offsetFromDotX={tourtipPreviewDesktopXY.left}*/}
            {/*  />*/}
            {/*) : null}*/}
          </div>
        </>
      )}
    </div>
  );
};
